var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"vs-input--label",attrs:{"for":""}},[(_vm.selected)?_c('span',[_vm._v("Search Coupons")]):_vm._e()]),_c('v-select',{attrs:{"options":_vm.coupons,"placeholder":"Search Coupons"},on:{"search":_vm.fetchCoupons},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }